// Design tokens for the Add-new modal's "modernist" look (Post Composer.dc.html
// mockup). Scoped to this modal only — the rest of the CMS stays on the
// existing light theme, so these are plain JS constants, not global CSS vars.
//
// The mockup's exact hex values live in a Claude Design canvas asset bundle
// (_ds/modernist-<id>/styles.css) that isn't part of this codebase — these
// are a best-match reconstruction from what's visible in the mockup markup
// (dark #201e1d backdrop, light bordered card, warm neutral/accent scale),
// not guaranteed pixel-identical to the original tool's resolved palette.
const modernist = {
  backdrop: '#201e1d',
  bg: '#F7F4EF',
  text: '#1A1817',
  neutral200: '#EDEAE4',
  neutral300: '#DDD8CF',
  neutral400: '#C7C0B4',
  neutral500: '#A79E8E',
  neutral600: '#8A8175',
  neutral700: '#5C554C',
  neutral800: '#332F2A',
  accent: '#C4551D',
  accentDark: '#9A4216',
  accentLight: '#F3E1D3',
  shadowLg: '0 24px 60px rgba(0, 0, 0, 0.35)',
  // Same font the rest of the CMS uses (see components/Text.js), not the
  // mockup's own Archivo — kept consistent with every other screen.
  fontHeading: "'CeraPro', sans-serif",
  fontBody: "'CeraPro', sans-serif"
};

export default modernist;
